export const iconFontAwesomeAutomotiveGaugeSimple = (
	<i className="fa-solid fa-gauge-simple"></i>
);
